import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import immutable from 'immutable'
import DatePicker from 'react-datepicker'
import TimePicker from 'rc-time-picker'
import moment from 'moment'
import axios from 'axios'

import legUtil from '../util/leg.util'

import {AutoComplete} from '../widgets/autocomplete/autocomplete.component'

const ELASTISEARCH_URL = '/api/v1/attractions/autocomplete/'
const TIME_FORMAT = 'h:mm a'
const TIME_NOW = moment().hour(0).minute(0).format(TIME_FORMAT)

export class ActivityEntry extends React.Component {
    constructor(props) {
        super(props)

        this._hasActivity = this.props.item ? true : false

        // These need a test as they can't be empty or we get an "uncontrolled input" error
        let defaultAddress1    = ''
        let defaultAddress2    = ''
        let defaultPhone       = ''
        let defaultWebsite     = ''

        if (!this.props.item) {
            this._item = new immutable.fromJS({}) // need an empty one if we don't have one passed in (ex: add my own)
        } else {
            if (!this.props.item.get('activity_guid')) {
                let targetId = this.props.item.get('place_id')
                // we have to get the actual object that should now be in the active leg
                this._item = this.props.leg.get('activities').find(function(act) {return act.get('place_id') === targetId})
            } else {
                this._item = this.props.item
            }    

            defaultAddress1 = this._item.getIn(['reservation_details', 'address_line_1']) ? this._item.getIn(['reservation_details', 'address_line_1']) : this._item.get('address') ? this._item.get('address') : ''
            defaultAddress2 = this._item.getIn(['reservation_details', 'address_line_2']) ? this._item.getIn(['reservation_details', 'address_line_2']) : ''
            defaultPhone    = this._item.getIn(['reservation_details', 'phone_number']) ? this._item.getIn(['reservation_details', 'phone_number']) : this._item.get('phone_number') ? this._item.get('phone_number') : ''
            defaultWebsite  = this._item.getIn(['reservation_details', 'website']) ?  this._item.getIn(['reservation_details', 'website']) : ''    
        }
        // TODO: Something is off about the website, potentially when it moved to details. Need to confirm behavior on new db

        let reservationDate = null
        if (this.props.arrivalDate) {
            let start = this.props.leg.getIn(['properties', 'start'])
            reservationDate = this.props.arrivalDate.clone().add(start, 'days')
        }

        this.state = {
            selectedActivity: this._item ? this._item.toJS() : null,
            searchactivity: this._item.get('name') ? this._item.get('name') : '',
            reservation_date: this._item.getIn(['reservation_details', 'reservation_date']) ? moment(this._item.getIn(['reservation_details', 'reservation_date'])) : reservationDate,
            reservation_time: this._item.getIn(['reservation_details', 'reservation_time']) ? this._item.getIn(['reservation_details', 'reservation_time']) : null,
            address1: defaultAddress1,
            address2: defaultAddress2,
            phone_number: defaultPhone,
            website: defaultWebsite,
            notes: this._item.getIn(['reservation_details', 'notes']) ? this._item.getIn(['reservation_details', 'notes']) : '',
            numguests: this._item.getIn(['reservation_details', 'numguests']) ? this._item.getIn(['reservation_details', 'numguests']) : '',
            confirmation_code: this._item.getIn(['reservation_details', 'confirmation_code']) ? this._item.getIn(['reservation_details', 'confirmation_code']) : '',
        }

        _.bindAll(this,
            'goBack',
            'updateReservationDate',
            'submitCustomActivity',
            'onExecuteQuery',
            'onRenderResult',
            'onChoose',
            'refreshFields',
            'getForm',
            'handleChange'
        )
    }

    handleChange(target, value) {
        this.setState({[target]: value})
    }

    componentDidMount() {
        this.refreshFields()
    }

    refreshFields() {
    // evertime we auto set a field, we have to trigger the class change to move the label up/down
        $('.input-plain input').each(function() {
            var target = $(this)
            if (target.parent().hasClass('react-datepicker__input-container') || target.parent().hasClass('rc-time-picker')) {
                // datepicker is nested 1 level deeper
                target.parent().parent().removeClass('is-focused')
                target.val() ? target.parent().parent().addClass('has-value') : target.parent().parent().removeClass('has-value')
            } else {
                target.parent().removeClass('is-focused')
                target.val() ? target.parent().addClass('has-value') : target.parent().removeClass('has-value')
            }
        })
    }

    onExecuteQuery(q) {
        return axios.get(ELASTISEARCH_URL, {
            params: {
                query: q
            }
        }).then((response) => response.data)
    }

    componentDidUpdate(prevProps, prevState) {
        this.refreshFields()
    }

    onRenderResult(result) {
        return (
            <div className="result-item">
                <div className="result-label">
                    <div className="result-name">{result.name}</div>
                </div>
            </div>
        )
    }

    onChoose(choice) {
        if (typeof choice === 'string') {
            // tempAccom comes back as a JSON obj
            let tempAct = legUtil.formatActivity(immutable.fromJS({name: choice}), this.props.user)
            this.setState({selectedActivity: tempAct})
        } else {
            // tempAccom comes back as a JSON obj
            let tempAct = legUtil.formatActivity(immutable.fromJS(choice), this.props.user)
            this.setState({
                selectedActivity: tempAct,
                address1: this.state.address1 ? this.state.address1 : choice.address ? choice.address : '',
                address2: this.state.address2 ? this.state.address2 : '',
                phone_number: this.state.phone_number ? this.state.phone_number : choice.phone_number ? choice.phone_number : '',
                // website : choice.website
            })
        }
    }

    goBack() {
        if (this.props.goBack) {
            this.props.goBack()
        } else {
            this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACTIVITIES, this.props.availableDetailSubSections.SEARCH)
        }
    }

    updateReservationDate(evt) {
        let newResDate = evt ? moment(evt) : null
        let resDateIsInPast = moment(newResDate).isBefore(moment())
        if (resDateIsInPast) {
            alert('Reservation date cannot be in the past.')
            return null
        }
        this.setState({
            reservation_date: newResDate
        })
    }

    submitCustomActivity() {
        if (!this.state.selectedActivity || this.state.selectedActivity.name === '' || this.state.selectedActivity.name == undefined) {
            alert('You must set a name for this item')
            return
        }

        // NOTE: If for some reason we want to let the user not select an item from the autocomplete, use this.refs.searchactivity.state.value to get the typed value

        let actObj = this.state.selectedActivity
        actObj.reservation_details =
                    {          
                        address_line_1: this.refs.address1.value ? this.refs.address1.value : this.state.selectedActivity.address_line_1,
                        address_line_2: this.refs.address2.value ? this.refs.address2.value : this.state.selectedActivity.address_line_2,
                        phone_number: this.refs.phone_number.value ? this.refs.phone_number.value : this.state.selectedActivity.phone_number,
                        website: this.refs.website.value ? this.refs.website.value : this.state.selectedActivity.website,
                        confirmation_code: this.refs.confirmation_code.value ? this.refs.confirmation_code.value : '',
                        reservation_date: this.state.reservation_date,
                        reservation_time: this.state.reservation_time ? this.state.reservation_time : '',
                        numguests: this.refs.numguests.value ? this.refs.numguests.value : '', 
                        notes: this.refs.notes.value ? this.refs.notes.value : ''
                    }
                

        let activity = immutable.fromJS(actObj)

        if (this._hasActivity) {      
            this.props.onUpdateActivityReservation(this.props.leg, activity)
            this.props.onModalHide()
        } else {
            this.props.onSelectActivity(this.props.leg, activity, this.props.user)
            this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACTIVITIES, this.props.availableDetailSubSections.OVERVIEW)
        }
    }

    getForm() {
        let onDateBlur = (evt) => {
            if (evt.target.name == 'reservation_date' && this.state.reservation_date == null) {
                evt.target.parentElement.parentElement.className = evt.target.parentElement.parentElement.className.replace( /(?:^|\s)is-focused(?!\S)/g, '' )
            }
        }

        let onDateFocus = (evt) => {
            evt.target.parentElement.parentElement.className = evt.target.parentElement.parentElement.className.replace( /(?:^|\s)is-focused(?!\S)/g, '' )
            evt.target.parentElement.parentElement.className += ' is-focused'
        }

        let nameField = <AutoComplete
                      type='attraction'
                      onExecuteQuery={this.onExecuteQuery}
                      onRenderResult={this.onRenderResult}
                      onChoose={this.onChoose}
                      hideEmpty={true}
                      useCustomEntry={true}
                      searchClass='user-entry'
                      placeholder='Activity Name'
                      ref="searchactivity"/>

        // override
        if (this._hasActivity) {
            nameField = <div className="form-group input-plain">
                <h1>{this._item.get('name')}</h1>
                <input
                      type="hidden"
                      name="search-activity"
                      className="form-control input-medium"
                      ref="searchactivity"
                      value={this.state.searchactivity} 
                      onChange={() => {this.handleChange('searchactivity', this.refs.searchactivity.value)}}/>
            </div>                  
        }

        return (
            <div>
                <div className="row">
                    <div className="row">
                        <div className="col-sm-12">
                            {nameField}
                        </div>
                    </div>
              
                    <div className="row">
                        <div className="col-sm-6">
                            <h2>Reservation Details</h2>
                            <div className="form-group input-plain">
                                <label htmlFor="confirmation_code">Confirmation Number</label>
                                <input
                      type="text"
                      name="confirmation_code"
                      className="form-control input-medium"
                      ref="confirmation_code"
                      value={this.state.confirmation_code} 
                      onChange={() => {this.handleChange('confirmation_code', this.refs.confirmation_code.value)}}/>
                            </div>
                            <div className="form-group input-plain">
                                <label htmlFor="reservation_date">Reservation Date</label>
                                <DatePicker
                      name='reservation_date'
                      dateFormat='MMMM D, YYYY'
                      className='form-control input-medium'
                      isClearable={false}
                      onFocus={onDateFocus}
                      onBlur={onDateBlur}
                      selected={this.state.reservation_date}
                      ref="reservation_date"                
                      value={this.state.reservation_date} 
                      onChange={this.updateReservationDate}/>
                            </div>

                            <div className="form-group input-plain">
                                <label htmlFor="reservation_time">Reservation Time</label>
                                <TimePicker
                      showSecond={false}
                      defaultValue={this.state.reservation_time ? moment(this.state.reservation_time) : null}
                      value={this.state.reservation_time ? moment(this.state.reservation_time) : null}
                      className='form-control input-medium'
                      name="reservation_time"
                      ref="reservation_time"
                      onChange={(value) => {value ? this.handleChange('reservation_time', value.format()) : this.handleChange('reservation_time', null) }}
                      format={TIME_FORMAT}
                      use12Hours/>
                            </div>

                            <div className="form-group input-plain">
                                <label htmlFor="numguests">Number of Guests</label>
                                <input
                      type="text"
                      name="numguests"
                      className="form-control input-medium"
                      ref="numguests"
                      value={this.state.numguests} 
                      onChange={() => {this.handleChange('numguests', this.refs.numguests.value)}}/>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <h2>Contact Details</h2>
                            <div className="form-group input-plain">
                                <label htmlFor="phone">Phone</label>
                                <input
                      type="text"
                      name="phone_number"
                      className="form-control input-medium"
                      ref="phone_number"
                      value={this.state.phone_number} 
                      onChange={() => {this.handleChange('phone_number', this.refs.phone_number.value)}}/>
                            </div>
                            <div className="form-group input-plain">
                                <label htmlFor="website">Website</label>
                                <input
                      type="text"
                      name="website"
                      className="form-control input-medium"
                      ref="website"
                      value={this.state.website} 
                      onChange={() => {this.handleChange('website', this.refs.website.value)}}/>
                            </div>
                            <div className="form-group input-plain">
                                <label htmlFor="address1">Address Line 1</label>
                                <input
                      type="text"
                      name="address1"
                      className="form-control input-medium"
                      ref="address1"
                      value={this.state.address1} 
                      onChange={() => {this.handleChange('address1', this.refs.address1.value)}}/>
                            </div>
                            <div className="form-group input-plain">
                                <label htmlFor="address2">Address Line 2</label>
                                <input
                      type="text"
                      name="address2"
                      className="form-control input-medium"
                      ref="address2"
                      value={this.state.address2} 
                      onChange={() => {this.handleChange('address2', this.refs.address2.value)}}/>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <h2>Notes</h2>
                            <div className="form-group input-plain text-area">
                                <textarea
                      name="notes"
                      className="form-control input-medium"
                      ref="notes"
                      value={this.state.notes} 
                      onChange={() => {this.handleChange('notes', this.refs.notes.value)}}/>
                                <br/>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group">
                            <button
                    type="submit"
                    onClick={() => { this.submitCustomActivity() }}
                    className="btn btn-medium btn-blue">
                      Save Details
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (this.props.isModal) {
            return ( <div ref="entryform" className="modal-form">{ this.getForm() }</div> )
        } else {
            return (
                <div className="view-area">
                    <div className="view-left-col">
                        <a onClick={() => this.goBack() } className="btn">Go Back</a>
                    </div>
                    <div className="view-center">
                        <div className="label-block">
                            <h1>MY ACTIVITY DETAILS</h1>
                        </div>
                        <div className="row">
                            { this.getForm() }
                        </div>
                    </div>
                    <div className="view-right-col"/>
                </div>
            )
        }
    }
}


// this.handleChange("reservation_time", value.format(TIME_FORMAT))

// <div className="form-group input-plain">
//   <label htmlFor="reservation_time">Reservation Time</label>
//   <input
//     type="text"
//     name="reservation_time"
//     className="form-control input-medium"
//     ref="reservation_time"
//     value={this.state.reservation_time} 
//     onChange={() => {this.handleChange("reservation_time", this.refs.reservation_time.value)}}
//   />
// </div>